import { useMutation, useQueryClient } from "@tanstack/react-query";

import { axiosInstanceNamek } from "@/service/Axios";
import { INamekError, NamekError } from "@/models";

import { ASSIGN_MATERIALS_KEYS } from "../../assignMaterials/services/queryKeys";

import { MATERIALS_KEYS as KEYS } from "./queryKeys";

type UpdateMaterialBody = {
  id: number;
  name: string;
};

const patchUpdateMaterial = (data: UpdateMaterialBody) => {
  return axiosInstanceNamek
    .patch(`v1/materials/${data.id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new NamekError(error.response?.data);
    });
};

export const useUpdateMaterial = () => {
  const queryClient = useQueryClient();

  return useMutation<number, INamekError, UpdateMaterialBody>({
    mutationFn: (data: UpdateMaterialBody) => patchUpdateMaterial(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [KEYS.RECORDS] });
      queryClient.invalidateQueries({
        queryKey: [ASSIGN_MATERIALS_KEYS.RECORDS],
        refetchType: "all",
      });
    },
  });
};
